module.exports = __webpack_public_path__ + "202a196b0497349de576c0ba3a357db2.png";